import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/home/home";
import PrivacyPolicy from "./pages/privacyPolicy";
import PrivacyPolicyPlaneGame from "./pages/privacyPolicyPlaneGame";
import PrivacyPolicyPMathPuzzles from "./pages/privacyPolicyMathPuzzles";
import AdsTxt from "./AdsTxt";
import TermsOfUse from "./pages/termsOfUse";
import PrivacyPolicyTracktorGps from "./pages/privacyPolicyTracktorGps";
import TermsOfUseTractorGps from "./pages/termsOfUseTractorGps";
import TermsOfUseLocation from "./pages/terms-of-use";
import PrivacyPolicyLocation from "./pages/privacy-policy";
export default function App() {
  return (
    <Router>
      <div className="body">
        <Routes>
          <Route path="/app-ads.txt" element={<AdsTxt />} />
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/privacypolicy/:id" element={<PrivacyPolicy />} />
          <Route
            path="/privacypolicyTracktorGps"
            element={<PrivacyPolicyTracktorGps />}
          />
          <Route path="/termsOfUse/:id" element={<TermsOfUse />} />
          <Route
            path="/termsOfUseTractorGps"
            element={<TermsOfUseTractorGps />}
          />
          <Route
            path="/privacypolicyPlaneGame"
            element={<PrivacyPolicyPlaneGame />}
          />
          <Route
            path="/privacyPolicyMathPuzzles"
            element={<PrivacyPolicyPMathPuzzles />}
          />

          <Route path="/terms-of-use/:id" element={<TermsOfUseLocation />} />
          <Route
            path="/privacy-policy/:id"
            element={<PrivacyPolicyLocation />}
          />
        </Routes>
      </div>
    </Router>
  );
}
